import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../../../primaryComponents";
import secondaryComponents from "../../..";
import { formatCurrency } from "../../../../../helpers";
import { useCardListener } from "./useCardListener";
import { CheckMarkCircle, TimesCircle } from "../../../../../assets/svgIcons";
import styles from "./styles.module.scss";

export const CardListener = ({
  amount = 0,
  paymentProvider,
  closeModal = () => {},
}) => {
  const {
    isLoading,
    paymentStatus,
    countDown,
    isCreatingOrder,
    hitThirdParty,
    isCheckingStatus,
    isCanceling,
    sessionDetails,
    terminalDetails,
    triggerSessionCreation,
    cancelTransaction,
    setHitThirdParty,
    proceedToNext,
  } = useCardListener({
    amount,
    paymentProvider,
    closeModal,
  });

  return (
    <>
      <div>
        <div className={styles.routedModal__header}>
          <h4 className="mb-0">Accept Card Payments</h4>

          <primaryComponents.Button
            classNames={"btn btn--outline-red"}
            isDisabled={paymentStatus === "PAID" || isCanceling}
            isLoading={isCanceling}
            loadingText={"Canceling..."}
            onClick={() => {
              if (!sessionDetails) return closeModal();

              cancelTransaction();
            }}
          >
            Cancel Payment
          </primaryComponents.Button>
        </div>

        <div className="text-center">
          <h3 className="my-5">{formatCurrency({ value: amount })}</h3>

          {terminalDetails ? (
            <secondaryComponents.LoaderHelper
              isLoading={isLoading}
              classNames={"mt-4"}
            >
              <div
                className={`${globalStyles.cardWithBorder} flex-row align-items-center justify-content-center`}
                style={{ minHeight: "150px" }}
              >
                {paymentStatus === "PENDING" ||
                paymentStatus === "PROCESSING" ? (
                  <div>
                    <h6>
                      Payment session has been sent to the terminal assigned to
                      this device and store
                    </h6>
                    <p>
                      Kindly ask the customer to insert their card and enter
                      their pin
                    </p>

                    <secondaryComponents.LoaderHelper
                      classNames={"mt-4"}
                      isLoading={true}
                    ></secondaryComponents.LoaderHelper>
                    <p className="smallest-text-size">Listening for payment</p>
                  </div>
                ) : paymentStatus === "PAID" ? (
                  <div>
                    <CheckMarkCircle
                      className="success--text"
                      style={{ fontSize: "50px" }}
                    />
                    <h5 className="success--text">Card Payment Successful</h5>
                    <p>
                      Confirming payment in{" "}
                      <span className="purple--text">{countDown}</span>
                    </p>
                  </div>
                ) : (
                  <div>
                    <TimesCircle
                      className="error--text"
                      style={{ fontSize: "50px" }}
                    />
                    <h5 className="error--text">Card Payment Failed</h5>
                  </div>
                )}
              </div>

              <div className={`${globalStyles.bottomButtonCover} mt-5`}>
                <primaryComponents.Button
                  className="btn btn--outline cover"
                  isDisabled={paymentStatus !== "FAILED" || isLoading}
                  isLoading={isLoading}
                  loadingText={"Resending..."}
                  onClick={() => triggerSessionCreation()}
                >
                  Resend Payment to POS
                </primaryComponents.Button>
                {paymentStatus === "PAID" ? (
                  <primaryComponents.Button
                    className="btn btn--success cover"
                    isDisabled={isCreatingOrder}
                    isLoading={isCreatingOrder}
                    loadingText={"Processing..."}
                    onClick={() => proceedToNext()}
                  >
                    Create Order
                  </primaryComponents.Button>
                ) : (
                  <primaryComponents.Button
                    className="btn btn--primary cover"
                    isDisabled={isCheckingStatus && hitThirdParty}
                    isLoading={isCheckingStatus && hitThirdParty}
                    loadingText={"Confirming..."}
                    onClick={() => setHitThirdParty(true)}
                  >
                    Payment Has Been Made
                  </primaryComponents.Button>
                )}
              </div>
            </secondaryComponents.LoaderHelper>
          ) : (
            <>
              <TimesCircle
                className="error--text"
                style={{ fontSize: "50px" }}
              />
              <h4 className="font-weight-normal">
                Please assign a terminal to this device to procced with transfer
              </h4>
            </>
          )}
        </div>
      </div>
    </>
  );
};
